// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment-section[data-v-fa0dcab6]{margin-top:60px}@media(max-width:1279px){.shipment-section[data-v-fa0dcab6]{margin-top:20px}}", ""]);
// Exports
module.exports = exports;
